import Button from '@material-ui/core/Button';
import ModalCustom from 'components/Shared/ModalCustom';
import { enStatus } from 'interface/course';
import { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import courseService from 'services/course';
import { onAcceptModules } from 'actionCreators/modules';
import { fetchCourse } from 'actionCreators/course';
import { connect, useDispatch } from 'react-redux';

interface IProps {
  courseStatus: enStatus;
  content: string;
  onAcceptModules?: typeof onAcceptModules;
}

const Terms = (props: IProps) => {
  const [open, setOpen] = useState(true);
  const [errorOnAcceptTerms, setErrorOnAcceptTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const params = useParams<{ courseHash: string }>();
  const history = useHistory();
  const dispatch = useDispatch();

  const handleAction = async (accepted: boolean) => {
    try {
      setLoading(true);
      await courseService.setAcceptedTerm(params.courseHash, accepted);
      props.onAcceptModules();
      if (accepted) {
        dispatch(fetchCourse(params.courseHash, true));
      }
      setOpen(false);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setErrorOnAcceptTerms(true);
    }
  };

  const refused = () => {
    handleAction(false);
    history.push('/vitrine');
  };

  const accepted = () => {
    handleAction(true);
  };

  const comeBackLater = () => {
    history.push('/vitrine');
  };

  if (!(props.courseStatus === enStatus.MUST_ACCEPT_TERM)) {
    return null;
  }

  return (
    <ModalCustom
      aria-label='Termos de aceite do curso'
      open={open}
      modalTitle='Termos e condições de Uso'
      modalContent={!errorOnAcceptTerms ? props.content : `Ops! Algo deu errado. Tente novamente em alguns minutos`}
    >
      {!loading && errorOnAcceptTerms && <Button onClick={comeBackLater}>Ok</Button>}
      {!loading && !errorOnAcceptTerms && <Button onClick={refused}>Discordo</Button>}
      {!errorOnAcceptTerms && (
        <Button disabled={loading} onClick={accepted}>
          {!loading ? 'Concordo' : 'Aguarde...'}
        </Button>
      )}
    </ModalCustom>
  );
};

const mapStateToProps = (state: any, ownProps: IProps) => ({
  ...ownProps,
});

export default connect(mapStateToProps, { onAcceptModules })(Terms);
